import get from "lodash/get";
import trimEnd from "lodash/trimEnd";
import { object, string } from "prop-types";
import React from "react";
import { useSelector } from "react-redux";

import { Link } from "@quintype/components";

import "./breadcrumb.m.css";

const BreadCrumb = ({ story, type }) => {
  const qt = useSelector((state) => get(state, ["qt"]));
  const author = get(qt, ["data", "author"], {});
  const section = get(story, ["slug"], "").split("/");
  const allStorySections = get(story, ["sections"], []);
  const allSections = get(qt, ["config", "sections"], []);
  const currentSection = get(qt, ["data", "section"], {});
  const staticPageTitle = get(qt, ["data", "title"], "");
  const magazinePageTitle = get(qt, ["data", "magazineIssue", "data", "name"], "");
  const tagPageData = get(qt, ["data", "tag"], {});

  const pathname = typeof window !== "undefined" ? window.location.pathname : "";
  const isManageSubscription = pathname === "/profile/subscription";

  let breadCrumbs = [];

  const getSectionObject = (currentSlug) => allStorySections.find((a) => a.slug === currentSlug);
  function buildBreadCrumbs(sectionSlugs, breadCrumbs = []) {
    if (sectionSlugs.length === 0) return breadCrumbs;

    const [currentSlug, ...remainingSlugs] = sectionSlugs;
    const currentSection = getSectionObject(currentSlug);

    if (currentSection) {
      breadCrumbs.push(currentSection);
      return buildBreadCrumbs(remainingSlugs, breadCrumbs);
    } else if (type === "story-page") {
      breadCrumbs.push(story.headline);
    }
    return breadCrumbs;
  }
  function transformString(str) {
    return str
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  if (type === "story-page" || type === "custom-event-page") {
    let currentSlug = "";
    section.forEach((crumb, index) => {
      if (index < section.length - 1) {
        currentSlug = currentSlug.concat(crumb, "/");
        breadCrumbs.push({ name: transformString(crumb), slug: trimEnd(currentSlug, "/") });
      } else if (index === section.length - 1) {
        breadCrumbs.push({});
      }
    });
  } else {
    breadCrumbs = buildBreadCrumbs(section);
  }

  if (type === "section-page") {
    const parentSectionId = get(qt, ["data", "section", "parent-id"], "");
    let parentSection = {};
    parentSectionId && (parentSection = allSections?.find((section) => section?.id === parentSectionId));
    parentSection?.name && breadCrumbs.push(parentSection);
    breadCrumbs.push(currentSection);
  }

  let content;
  switch (type) {
    case "story-page":
      content = story?.headline;
      break;
    case "author-page":
      const authors = { name: "Author", slug: "author" };
      breadCrumbs.push(authors, author);
      content = author?.name;
      break;
    case "section-page":
      content = currentSection?.name;
      break;
    case "authors-list":
      breadCrumbs.push({});
      content = "Author";
      break;
    case "static-page":
      breadCrumbs.push({});
      content = staticPageTitle;
      break;
    case "tag-page":
      breadCrumbs.push({ name: "Tag" }, { name: tagPageData?.name });
      content = tagPageData?.name;
      break;
    case "custom-event-page":
      content = story?.headline;
      break;
    case "search-page":
      breadCrumbs.push({});
      content = `Search`;
      break;
    case "all-magazines-listing-page":
      breadCrumbs.push({});
      content = `Magazine`;
      break;
    case "magazines-issue-landing-page":
      breadCrumbs.push({ name: "Magazine", slug: "magazine" }, { name: magazinePageTitle });
      content = magazinePageTitle;
      break;
    case "subscribe-page":
      breadCrumbs.push({});
      content = "Subscribe";
      break;
    default:
      content = "";
  }

  return (
    <div styleName="breadcrumb-wrapper" className="breadcrumb-wrapper">
      <div styleName="breadcrumb" className="breadcrumb">
        <Link href="/" disableAjaxLinks={true}>
          <span styleName="brand-color" className="brand-color">
            Home
          </span>
        </Link>
        {breadCrumbs.map((crumb, index) => {
          if (index === 0 && type === "tag-page") {
            return (
              <span key={index} styleName="headline-text" className="breadcrumb-headline-text">
                {crumb.name}
              </span>
            );
          }

          if (index === breadCrumbs.length - 1) {
            return (
              <span key={index} styleName="headline-text" className="breadcrumb-headline-text ellipsis">
                {content}
              </span>
            );
          }

          return (
            <Link key={index} href={`/${crumb.slug}`} disableAjaxLinks={true}>
              <span styleName="brand-color" key={index} className="brand-color">
                {crumb.name}
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

BreadCrumb.propTypes = {
  story: object,
  type: string,
};

export default BreadCrumb;
